import { useTranslation } from 'react-i18next';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';

import useSearchBar, { UseSearchBarProps } from './hooks';

type Props = UseSearchBarProps & {
  className?: string;
  disabled?: boolean;
};

const SearchBar = (props: Readonly<Props>): React.JSX.Element => {
  const { t } = useTranslation('search');

  const { className, disabled } = props;
  const { localSearchValue, changeLocalValue } = useSearchBar(props);

  return (
    <TextField
      className={className}
      placeholder={t('searchBarPlaceHolder')}
      variant="outlined"
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => changeLocalValue(event.target.value)}
      value={localSearchValue}
      disabled={disabled}
      slotProps={{
        input: {
          sx: { borderRadius: 40 },
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: (
            <IconButton
              sx={{
                visibility: localSearchValue ? 'visible' : 'hidden',
              }}
              onClick={() => changeLocalValue('')}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        },
      }}
      size="small"
    />
  );
};

export default SearchBar;
